<template>
  <div v-if="!cookiesAccepted && showPopupModal && !$route.path.startsWith('/f/') && !$route.query.screenshot" id="cookie-law-info-bar">
    <div class="container">
      <div class="text-wrapper">
        <p>
          We use cookies to improve your experience.
        </p>
        <p>
          StatisticsCalculators.com uses cookies to personalize content, deliver relevant ads, and improve site performance. We also share information about your use of our site with our advertising and analytics partners, who may combine it with other information you’ve provided to them or they’ve collected from your use of their services. 
          <nuxt-link to="/privacy-policy/" target="_blank" class="more">
            Privacy Policy
          </nuxt-link> to learn more.
        </p>
      </div>
      <span class="ok btn-primary" @click.prevent="acceptCookies"> Accept </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cookiesAccepted: true,
    };
  },
  computed: {
    companyName() {
      if (this.$config.platform === 'ds') {
        return this.$config.platformName;
      }

      return '365 Company Ltd';
    },
    showPopupModal() {
      return !this.$store.state.modals.opened.some((modal) => modal.name === 'gallery');
    },
  },
  mounted() {
    this.cookiesAccepted = localStorage.getItem('cookiesAccepted');
  },
  methods: {
    acceptCookies() {
      this.cookiesAccepted = true;
      localStorage.setItem('cookiesAccepted', this.cookiesAccepted);
    },
  },
};
</script>

<style lang="scss" scoped>
#cookie-law-info-bar {
  font-size: 14px;
  margin: 0 auto;
  padding: 16px 24px;
  position: fixed;
  text-align: left;
  box-sizing: border-box;
  width: 100%;
  z-index: 9999;
  display: block;
  left: 0;
  font-weight: 400;
  box-shadow: 0 4px 15px 0 rgba(0, 12, 31, 0.25);
  background-color: var(--main-light-shade-1);
  color: var(--main-dark);
  font-family: inherit;
  bottom: 0;
  transition: all 300ms ease;
  line-height: 18px;

  .container {
    display: flex;
    align-items: center;

    p {
        margin: 0;

        &:first-of-type {
            margin-bottom: 8px;
            font-size: 18px;
        }
    }

    .ok {
      display: inline-block;
      padding: 0.9em 1.7em;
      text-decoration: none;
      position: relative;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      margin-left: 10px;
    }

    a.more {
      display: inline-block;
      color: #3D989E;
      font-weight: 600;
    }
  }
}

@include bp($bp-laptop) {
  #cookie-law-info-bar .container .ok {
    margin-left: 12px;
  }
}

@include bp($bp-mobile) {
  #cookie-law-info-bar {
    padding: 24px 0;

    .container {
      display: block;

      >span {
        display: block;
      }

      .ok {
        margin-top: 12px;
        margin-left: 0;
        padding: 12px 25px;
      }
    }
  }
}

@include bp($bp-phone) {
  #cookie-law-info-bar .container a.ok {
    width: 100%;
  }
}
</style>
